export const AUTH_API_ROUTES = {
  LOGIN: "customers/auth/login",
  REGISTRATION: "/customers/auth/signup",
  SEND_OTP: "/customers/auth/send-otp"
};
